import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import NotificationsPageUI from './NotificationsPageUI.js'

class NotificationsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      projectList: null,
      filteredProjectList: null,
      emailAcceptance: null,
      submitted: false,
      searchFilter: ''
    }
  }

  render() {
    return (
      <NotificationsPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        // user notif
        submitted={this.state.submitted}
        emailAcceptance={this.state.emailAcceptance}
        onEmailAcceptanceChange={this.onEmailAcceptanceChange}
        // project notif
        projectList={this.state.projectList}
        filteredProjectList={this.state.filteredProjectList}
        onProjectEmailAcceptanceChange={this.onProjectEmailAcceptanceChange}
        // refresh, filter
        onRefreshClick={this.onRefreshClick}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getUser(context)
    this.getProjects(context)
    this.getMessages(context)
  }

  getUser(context) {
    let cacheManager = new CacheManager({
      resource: '/api/user',
      cacheKey: CacheKeys.User(context.session.userId),
      callback: this.getUserCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getUserCallback = (response) => {
    console.log(response.emailAcceptance, response.emailAcceptance === 'accept');
    this.setState({errorList: response.errorList, emailAcceptance: response.emailAcceptance})
  }

  getProjects(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/projects`,
      cacheKey: CacheKeys.Projects(context.session.accountId, context.session.userId),
      callback: this.getProjectsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectsCallback = (response) => {
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }
    let projectList = response.projectList
      .filter(project => project.status !== 'archived' && project.roleId)
    projectList.forEach(project => project.submitted = false)
    this.setState({
      projectList: projectList,
    })
    this.applyFilters(projectList, this.state.searchFilter)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId))
    this.setState({
      errorList: null,
      projectList: null,
      filteredProjectList: null
    })
    this.getProjects(context)
  }

  onEmailAcceptanceChange = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    this.setState({submitted: true})
    RestApiUtils.put(this.props.context,
      '/api/user/emailAcceptance',
      this.onSubmitCallback, {
        emailAcceptance: this.state.emailAcceptance === 'accept' ? 'block' : 'accept',
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'emailAcceptance':
            this.setEmailAcceptanceError(error.message)
            break;
          default:
        }
      })
    }

    this.setState({
      submitted: false,
      errorList: errorList,
      successMsg: response.success
    })

    if (errorList.length === 0) {
      this.setState({
        emailAcceptance: this.state.emailAcceptance === 'accept' ? 'block' : 'accept',
      })
      CacheManager.removeObject(CacheKeys.User(this.props.context.session.userId));
    }
  }

  onProjectEmailAcceptanceChange = (event) => {
    let projectId = event.currentTarget.getAttribute('data-row-id')
    let projectList = this.state.projectList
    let projectA = projectList.filter(project => project.projectId === projectId)
    if (projectA.length === 0 || projectA[0].submitted)
      return
    projectA[0].submitted = true
    this.setState({projectList: projectList})
    RestApiUtils.put(this.props.context,
      `/api/user/projects/${projectId}/notifications`,
      this.onProjectSubmitCallback, {
        emailAcceptance: projectA[0].emailAcceptance === 'accept' ? 'block' : 'accept',
      }
    )
  }

  onProjectSubmitCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'emailAcceptance':
            this.setEmailAcceptanceError(error.message)
            break;
          default:
        }
      })
    }

    this.setState({
      errorList: errorList,
      successMsg: response.success
    })

    if (errorList.length === 0 && response.projectNotificationList.length > 0) {
      let context = this.props.context
      let project = this.state.projectList.filter(project =>  project.projectId === response.projectNotificationList[0].projectId)[0]
      project.submitted = false
      project.emailAcceptance = response.projectNotificationList[0].emailAcceptance
      this.setState({
        projectList: this.state.projectList
      })
      CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId));
    }
  }

  onSearchFilterChange = (event) => {
    console.log('here');
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.projectList, searchFilter)
  }

  applyFilters(projectList, searchFilter) {
    let filteredProjectList = projectList.filter(project => project.projectName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))
    this.setState({filteredProjectList: filteredProjectList})
  }

  getMessages(context) {
    let arr = [
      'c_refresh',
      'c_email_notifications',
      'c_all_notifications',
      'c_prj_notifications',
      'c_acc_notif_still_sent'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_notif', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default NotificationsPageSF
